import { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const BuildingBoldIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 7L12 3L2 3L2 21L22 21L22 7L12 7ZM6 19H4L4 17H6V19ZM6 15L4 15V13L6 13L6 15ZM6 11L4 11V9H6V11ZM6 7H4L4 5L6 5L6 7ZM10 19L8 19V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17L14 17V15L12 15L12 13L14 13V11L12 11V9H20L20 19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z"
        fill={color}
      />
    </svg>
  );
};
